import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

const PATH_TEMPLATE = '/creators/{creatorSlug}/product-types/{productTypeSlug}';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getProductTypeBySlug = async ({ creatorSlug, productTypeSlug }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorSlug, productTypeSlug });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getProductTypeBySlug;
